export interface BackendValidationError {
  error?: {
    errors?: Record<string, string[]>;
    message?: string;
    reason?: string;
  };
  message?: string;
}

/**
 * Convert BackendErrors to readable error messages and
 * decide whether to show errors in an toast
 * { errors: { field: [message] } }
 * Fallback error.message
 */
export function backendErrorsToText(error: BackendValidationError): string[] {
  const errors = error.error?.errors;

  if (errors && typeof errors === 'object') {
    return Object.entries(errors).flatMap(([key, messages]) => (messages ?? []).map(message => `${key}: ${message}`));
  }

  // Single message fallbacks
  const singleMessage = error.error?.message ?? error.error?.reason ?? error.message;
  return singleMessage ? [singleMessage] : ['Unknown error'];
}

export function showBackendErrors(toast: { error: (message: string) => void }, error: BackendValidationError): void {
  backendErrorsToText(error).forEach(message => toast.error(message));
}
